function initInfiniteScroll() {
  const scrollContainer = document.querySelector('[data-infinite-scroll]');
  const sentinel = document.getElementById('infinite-scroll-sentinel');
  if (!scrollContainer || !sentinel) {
    console.log('Infinite scroll not initialized: missing container or sentinel.');
    return;
  }

  let loading = false;
  let nextPageUrl = sentinel.querySelector('.next-page-link')?.href;

  if (!scrollContainer.style.position) {
    scrollContainer.style.position = 'relative';
  }

  const observer = new IntersectionObserver(entries => {
    if (entries[0].isIntersecting && !loading && nextPageUrl) {
      loading = true;
      console.log('Fetching more products from:', nextPageUrl);

      const loadingIndicator = document.createElement('div');
      loadingIndicator.id = 'loading-indicator';
      loadingIndicator.style.position = 'absolute';
      loadingIndicator.style.top = '50%';
      loadingIndicator.style.left = '50%';
      loadingIndicator.style.transform = 'translate(-50%, -50%)';
      loadingIndicator.style.zIndex = '9999';
      loadingIndicator.style.display = 'flex';
      loadingIndicator.style.justifyContent = 'center';
      loadingIndicator.style.alignItems = 'center';
      // loadingIndicator.innerHTML = '<img src="loading-spinner.gif" alt="Loading..."/>';

      scrollContainer.appendChild(loadingIndicator);

      fetch(nextPageUrl)
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newItems = doc.querySelector('#facets-results');
          const newPagination = doc.querySelector('.next-page-link');

          if (newItems) {
            const container = document.querySelector('#facets-results');
            container.insertAdjacentHTML('beforeend', newItems.innerHTML);

            // Only set opacity on newly added images
            const newImages = container.querySelectorAll('img');
            newImages.forEach(img => {
              img.style.opacity = 1;
            });
          }

          if (newPagination) {
            nextPageUrl = newPagination.href;
            loading = false;
          } else {
            nextPageUrl = null;
            sentinel.remove();
          }

          loadingIndicator.remove();
        })
        .catch(error => {
          console.error('Error fetching next page:', error);
          loading = false;
          loadingIndicator.remove();
        });
    }
  }, { rootMargin: '200px' });

  observer.observe(sentinel);
}

document.addEventListener('DOMContentLoaded', initInfiniteScroll);
document.addEventListener('shopify:section:load', initInfiniteScroll);
